module.exports = __webpack_public_path__ + "static/media/expandIcon.e319df1e.svg";